__turbopack_context__.v({
  "green": "iutEZG_green",
  "pill": "iutEZG_pill",
});
